<template>
    <div>
        <div
         v-for="(item, index) in video"
         :key="index"
         class="playerVideo"
         :id="`player${item.url}`"></div>
    </div>
</template>
<script>
import videoApi from '@/request/api/video';
export default {
    props: [ 'video' ],
    data() {
        return {
            player: []
        }
    },
    created() {
        console.log(polyvPlayer)
    },
    mounted() {
        this.createVideo();
    },
    beforeDestroy() {
        this.player.forEach(item => {
            item.j2s_stopVideo && item.j2s_stopVideo()
            item.destroy && item.destroy()
        })
    },
    methods: {
        //创建视频
        createVideo() {
            this.video.forEach(item => {
                videoApi.getPlaySafe(item.url, res => {
                    if (res.succeed) {
                        this.player.push(polyvPlayer({
                            wrap: `#player${item.url}`,
                            vid: res.data.polyvVid,
                            autoplay: false,
                            width: "100%",
                            height: "100%",
                            ts: res.data.ts,
                            sign: res.data.sign,
                            playsafe: res.data.playSafe
                        }))
                    }
                });
            })
        }
    }
}
</script>
<style scoped>
.playerVideo {
    width: 100%;
    height: 500px;
}
@media (max-width: 880px) { 
    .playerVideo {
        height: 300px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/resource/videoResource.vue